import React from 'react';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import {
  Card,
  CardActions,
  Divider,
  Button,
  CardHeader,
  Typography,
  CardContent,
  FormControlLabel,
  Switch
} from '@mui/material';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {},
  trial_button: {
    backgroundColor: '#fb8c00',
    color: '#fff',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: '#fb8c00',
      color: '#fff'
    }
  },
  activate_button: {
    backgroundColor: '#43a047',
    color: '#fff',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: '#43a047',
      color: '#fff'
    }
  },
  noUnderline: {
    textDecoration: 'none'
  }
});

const AccountSecurity = props => {
  const { className, onMfaRequiredToggle, account, ...rest } = props;
  const classes = useClasses(styles);

  // const isRequired = (account.mfa_required === true)

  let content = null

  content = 
    <React.Fragment>
      <CardContent>
        <FormControlLabel
              control={<Switch checked={account ? account.mfa_require : false} onChange={(event) => onMfaRequiredToggle(event, 'mfaRequired')} name="mfa_required" color="primary" />}
              label="Require Multi-Factor Authentication"
            />
      </CardContent>
      <Divider />
    </React.Fragment>

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title="Multi-Factor Authentication"
      />
      <Divider />
      {content}
    </Card>
  );
};


export default withErrorHandler(AccountSecurity, axios)